import React from 'react';

import { SuccessCriteria } from '../../../../types/work';
import {
    SuccessCriteriaContainer,
    SuccessCriteriaItem,
    SuccessCriteriaItemText,
    SuccessCriteriaItemTitle,
    SuccessCriteriaTitle
} from './styled';

type Props = {
  criteriaList: SuccessCriteria[];
};

const SuccessCriteriaDisplay: React.FC<Props> = ({ criteriaList }) => {
    if (!Array.isArray(criteriaList) || criteriaList.length === 0) {
        return null;
    }

    return (
        <SuccessCriteriaContainer>
            <SuccessCriteriaTitle>Success criteria</SuccessCriteriaTitle>
            {criteriaList.map((criteria, idx) => (
                <SuccessCriteriaItem key={idx}>
                    <SuccessCriteriaItemTitle>{criteria.title}</SuccessCriteriaItemTitle>
                    <SuccessCriteriaItemText>
                        <span>Description:</span> {criteria.description}
                    </SuccessCriteriaItemText>
                    <SuccessCriteriaItemText>
                        <span>Explanation:</span> {criteria.explanation}
                    </SuccessCriteriaItemText>
                </SuccessCriteriaItem>
            ))}
        </SuccessCriteriaContainer>
    );
};

export default SuccessCriteriaDisplay;
